import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { CategoryScale, Chart as Chartjs, Legend, LinearScale, LineElement } from "chart.js";

Chartjs.register(LineElement, LinearScale, CategoryScale, Legend)
const LineChart = ({ reportExtractData , fundName }) => {

    const [acwiData, setACWIData] = useState({ datasets: [] })
    const [spData, setSPData] = useState({ datasets: [] })
    useEffect(() => {
        let ACWI = [];
        let Sp500 = [];
        let halfMoonfirst = [];
        let halfMoonlast = [];
        const equity =  reportExtractData?.riskValues.filter(x=>x.name === "equity");

        for (let i = 0; i < reportExtractData?.totals.length; i++) {
            if (i < 6) {
                ACWI.push(reportExtractData?.totals[i]);
            } else {
                Sp500.push(reportExtractData?.totals[i]);
            }
        }
        for (let i = 0; i < equity[0]?.values?.length ; i++) {
            if (i < 6) {
                halfMoonfirst.push(equity[0]?.values[i]);
            } else {
                halfMoonlast.push(equity[0]?.values[i]);
            }
        }
        setACWIData({
            labels: ACWI?.map(x => x.toFixed(2)),
            datasets: [
                {
                    label: fundName,
                    data: halfMoonfirst?.map(y => y),
                    backgroundColor: "#8bfbe8",
                    borderColor: 'rgb(139, 251, 232, 0.7)'
                },
                {
                    label: "ACWI",
                    data: ACWI?.map(y => y),
                    backgroundColor: "#122e47",
                    borderColor: 'rgb(18, 46, 71 , 0.7)'
                }]
        });
        setSPData({
            labels: Sp500?.map(x => x.toFixed(2)),
            datasets: [
                {
                    label: fundName,
                    data: halfMoonlast?.map(y => y),
                    backgroundColor: "#8bfbe8",
                    borderColor: 'rgb(139, 251, 232, 0.7)'
                },
                {
                    label: "S&P500",
                    data: Sp500?.map(y => y),
                    backgroundColor: "#122e47",
                    borderColor: 'rgb(18, 46, 71 , 0.7)'
                }]
        });
    }, []);

    var options = {
        responsive: true,
        indexAxis: 'x',
        plugins: {
            legend: {
                position: 'bottom',
            }
        },
        scales: {
            y: {
                display: true
            },
            x: {
                display: false
            }
        }
    }

    return (
        <div>
            <div style={{ marginTop: "5%" }}>
                <Line data={acwiData} height={300} options={options} />
            </div>
            <div style={{ marginTop: "10%" }}>
                <Line data={spData} height={300} options={options} />
            </div>
        </div>
    );
};

export default LineChart;
